import { Flex, Typography } from "antd";
import { FC, useMemo } from "react";
import { AnyTask, Point, TaskRoute } from "tm-shared/types";

import { ASSIGNMENT_VOCABULARY } from "@/constants/ui/assignment";
import { PointActionsBar, pointToCopy } from "@/domains/point";
import { AssignmentWithContext } from "@/pages/Assignments/AssignmentsPage/AssignmentPage.types";
import { PointTasks } from "@/pages/WorkPlan/WorkPlanPage/sections/PointsSection/components/PointTasks";
import { ImageRowList } from "@/shared/ui/ImageRowList";
import { PrimaryText, SecondaryText } from "@/shared/ui/Typography";

import { StyledDivider } from "./Styled";

interface AssignmentBodyProps {
    item: AssignmentWithContext;
    onOpenTasksInfoModal: (params: { task: AnyTask; point: Point }) => void;
}

export const AssignmentBody: FC<AssignmentBodyProps> = ({
    item,
    onOpenTasksInfoModal,
}) => {
    const { assignment, allTasks, point } = item;

    const pointTasks = useMemo(() => Object.values(allTasks), [allTasks]);

    const incompleteRoutes = useMemo(() => {
        const set = new Set<TaskRoute>();
        for (const t of pointTasks) {
            if (!t.completed) set.add(t.context.route);
        }
        return set;
    }, [pointTasks]);

    return (
        <Flex vertical align="flex-start" justify="center" gap="16px">
            <PointActionsBar
                pointId={point.id}
                pointName={point.name ?? point.market.contragent.name}
                geo={point.market.building.geo}
                address={point.market.building.address?.name}
                objToCopy={pointToCopy(point)}
            />
            <Flex vertical gap="8px" align="flex-start" justify="center">
                <Flex justify="flex-start" align="center" gap="8px">
                    <SecondaryText color="disabled">
                        Тип доручення:
                    </SecondaryText>
                    <PrimaryText>
                        {
                            ASSIGNMENT_VOCABULARY?.[
                                assignment.context.additionalData.assignmentType
                            ]?.label
                        }
                    </PrimaryText>
                </Flex>

                <Typography
                    dangerouslySetInnerHTML={{
                        __html: assignment.context.description,
                    }}
                />
            </Flex>

            <ImageRowList images={assignment.context.files ?? []} />

            <StyledDivider />

            <PointTasks
                tasks={pointTasks}
                point={point}
                incompleteRoutes={incompleteRoutes}
                onOpenTasksInfoModal={onOpenTasksInfoModal}
                readonly
            />
        </Flex>
    );
};
